module.exports = __webpack_public_path__ + "static/favicon152-815e5a246b987978c833406af6289811.png";